// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.
const cognitoProdConfig = {
    aws_project_region: 'us-west-2',
    aws_cognito_identity_pool_id: 'us-west-2:1b95586b-80aa-42c2-829d-03ab9aeb1bb3',
    aws_cognito_region: 'us-west-2',
    aws_user_pools_id: 'us-west-2_RkIMDuCi2',
    aws_user_pools_web_client_id: '6licejjfjoksa24nc8m1nat3sn',
    oauth: {},
    aws_cloud_logic_custom: [
        {
            name: 'klaviyoapi',
            endpoint: 'https://yl0wr8cvy1.execute-api.ap-south-1.amazonaws.com/dev',
            region: 'ap-south-1'
        },
        {
            name: 'ordersapi',
            endpoint: 'https://sh45e3gzgf.execute-api.ap-south-1.amazonaws.com/dev',
            region: 'ap-south-1'
        }
    ]
};

export { cognitoProdConfig as default };
//# sourceMappingURL=aws-exports-prod.js.map
